import { Box, Button, Dialog, DialogContent } from "@mui/material";
import React from "react";
import Splitter from "../sign-in-splitter/Splitter";
import Login from "../login/Login";
import CloseIcon from "@mui/icons-material/Close";


const LoginDialog = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "700px",
          height: "620px",
          borderRadius: "10px",
          overflow: "hidden",
        },
      }}
    >
      <DialogContent sx={{ p: 0, height: "100%", overflow: "hidden" }}>
        <Box className="auth-dialog">
          {/* LEFT – SPLITTER (sticky) */}
          <Box className="auth-left">
            <Splitter variant="login" />
          </Box>

          {/* RIGHT – FORM (scrollable) */}
          <Box className="auth-right">
            <Button
              onClick={onClose}
              sx={{
                position: "absolute",
                top: 12,
                right: 12,
                minWidth: "auto",
                width: 36,
                height: 36,
                borderRadius: "50%",
                color: "#555",
                zIndex: 1,
                "&:hover": { backgroundColor: "#f0f0f0" },
              }}
            >
              <CloseIcon fontSize="small" />
            </Button>
            <Login />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LoginDialog;
